/* eslint-disable camelcase */
import compose from 'ramda/src/compose'
import map from 'ramda/src/map'
import { stringToBoolean, objToNumber, mappedIndex } from './general'

const rectangleLocation = l => {
  return new google.maps.LatLngBounds(objToNumber(l.sw), objToNumber(l.ne)).toJSON()
}

const migrateCircle = ({ id, strokeColor, fillColor, position: { center, radius }, locked, type }) => ({
  id,
  strokeColor,
  fillColor,
  type,
  location: objToNumber(center),
  radius: parseFloat(radius),
  locked: stringToBoolean(locked)
})

const migrateRectangle = ({ id, strokeColor, fillColor, position, locked, type }) => ({
  id,
  strokeColor,
  fillColor,
  type,
  location: rectangleLocation(position),
  locked: stringToBoolean(locked)
})

const migratePolyline = ({ id, strokeColor, path, locked, type }) => ({
  id,
  strokeColor,
  type,
  fillColor: '#ffffff',
  location: map(objToNumber, Object.values(path)),
  locked: stringToBoolean(locked)
})

const migratePolygon = ({ id, strokeColor, fillColor, paths, locked, type }) => ({
  id,
  strokeColor,
  fillColor,
  type,
  location: map(objToNumber, Object.values(paths)),
  locked: stringToBoolean(locked)
})

const migrateLabel =
  ({ id, strokeColor, fillColor, path, locked,
    type, text, dimensions: { width, height, baseFontSize }, position }) => ({
    id,
    strokeColor,
    fillColor,
    type,
    text,
    dimensions: {
      baseWidth: parseFloat(width),
      baseHeight: parseFloat(height),
      baseFontSize: parseFloat(baseFontSize) || 1
    },
    location: objToNumber(position),
    locked: stringToBoolean(locked)
  })

const migrateMarkup = (markup, index) => {
  switch (markup.type) {
    case 'circle':
      return migrateCircle({ ...markup, id: index })
    case 'rectangle':
      return migrateRectangle({ ...markup, id: index })
    case 'polyline':
      return migratePolyline({ ...markup, id: index })
    case 'polygon':
      return migratePolygon({ ...markup, id: index })
    case 'label':
      return migrateLabel({ ...markup, id: index })
    default:
      throw new Error('Invalid markup type')
  }
}

export default compose(
  mappedIndex(migrateMarkup),
  Object.values
)



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/migrateMarkups.js